/**
 * Created by idea on 14/04/2017.
 */
import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

declare var $: any;
@Injectable()
export class UploadService {
  private header: Headers;
  responseData: any;
  handleError: any;
  constructor(
    private http: Http,
    private router: Router
  ) {
    const contentHeaders = new Headers();
    this.header = contentHeaders;
  }

  uploadAudio(file, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    return this.postWithFile(environment.cdn_server + '/uploadAudio', file, postData);
  }

  upload(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    return this.postWithFile(environment.cdn_server + '/upload', file, postData);
  }

  uploadExcel(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    return this.postWithFile(environment.api_evs + '/upload-excel?type=json', file, postData);
  }

  public postWithFile(url: string, file: File, postData?: any) {
    const formData: FormData = new FormData();
    formData.append(`file`, file, file.name);
    if (postData !== '' && postData !== undefined && postData !== null) {
      for (const property in postData) {
        if (postData.hasOwnProperty(property)) {
          formData.append(property, postData[property]);
        }
      }
    }
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    return new Promise((resolve, reject) => {
      this.http
        .post(url, formData, {
          headers: this.header,
        })
        .subscribe(
          res => {
            this.responseData = res.json();
            resolve(this.responseData);
          },
          error => {
            reject(error.json());
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Upload.service.ts